import "./ClientFooter.css";

function ClientFooter() {
  return (
    <div className="footer">
      <div className="footer-inner">
        <div className="info">
          <p className="copyright">
            Công Thành Chiến 2005 - Phiên bản thử nghiệm
          </p>
        </div>
      </div>
    </div>
  );
}

export default ClientFooter;
